export const MAX_UPLOAD_SIZE = 10 ** 7;
export const HUMAN_READABLE_UPLOAD_SIZE = `${Math.floor(MAX_UPLOAD_SIZE / 10 ** 6)}MB`;

export const providerProfileLabels = {
  about: 'About Me',
} as const;

export const SUPPORT_EMAIL = 'hi@mantrahealth.com' as const;

// Instant placeholder while the support link queries resolve (see useSupportLink).
export const STATIC_DEFAULT_SUPPORT = {
  method: 'email',
  link: `mailto:${SUPPORT_EMAIL}`,
} as const;
